// http://goo.gl/XkBrjD
var $export = require('./$.export')
  , $values = require('./$.object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es7.object.values.js
// module id = 4999
// module chunks = 0